<!-- This component is shown with an animation. We can not add another animation to this component (angular bug), so we create an extra sub-component as a solution -->

<tun-search-result-content-view
  class="wrapper"
>

</tun-search-result-content-view>
